export const normalizeSlot = (name, scope = {}, $scopedSlots = {}, $slots = {}) => {
  // Note: in vue 2.6.x, all named slots are also scoped slots
  const slot = $scopedSlots[name] || $slots[name]

  return typeof slot === 'function' ? slot(scope) : slot
}
